export const dayCellCommonConstants = {
  borderLeftToday: '1px solid rgb(108, 117, 125)',
  disabledColor: 'rgba(85, 85, 85, 0.5)',
  disabledBackgroundColor: 'rgb(243, 243, 247)',
};
